import styled from 'styled-components';
import {
  Loader as LoaderLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  width: 100%;
`;

const Card = styled(SegmentLayoutComponent)`
  &&& {
    padding: 20px;
    width: 100%;
  }
`;

const ChartTitle = styled(TextLayoutComponent.Header)`
  margin-bottom: 25px;
`;

const Keyword = styled(TextLayoutComponent.Label)`
  font-size: 15px;
  margin-top: 10px;
`;

const MansoryContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
  word-wrap: break-word;

  :last-child {
    margin-bottom: 40px;
  }

  @media screen and (min-width: 1024px ) {
    width: 49%;
  };

  @media screen and (min-width: 1440px ) {
    width: 32%
  };

  @media screen and (min-width: 2560px ) {
    width: 23.5%
  };
`;

const MansoryGutter = styled.div`
  width: 0%;

  @media screen and (min-width: 1024px ) {
    width: 2%
  };
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

export {
  Card,
  ChartTitle,
  Container,
  Keyword,
  Loader,
  MansoryContainer,
  MansoryGutter,
};
